import ImageGrid from '../../../UI/ImageGrid/ImageGrid';
import Button from '../../../UI/Button/Button';
import heroBannerImage from '../../../../assets/DealsPage/HeroBanner.png';
import { Link as RouterLink } from 'react-router-dom';
import { Grid, Typography, Link } from '@mui/material';

const HeroBanner = (props) => {
  return (
    <Grid container spacing={6} alignItems='center' sx={{ mt: '1.5rem', my: '3rem' }}>
      <Grid item lg={6}>
        <Typography variant='h3' component='h1' sx={{ fontWeight: 'bold' }}>
          Save and explore with our{' '}
          <Typography variant='h3' component='span' sx={{ color: 'secondary.main', fontWeight: 'bold' }}>
            partners.
          </Typography>
        </Typography>
        <Typography variant='body1' sx={{ my: '2rem' }}>
          Get discounts with partners of The 100 Club. Simply show that you're a member of the community by flashing
          your 100Card at the outlet, and get exclusive perks.
        </Typography>
        <Link
          key={1}
          component={RouterLink}
          to={'/deals/tnc'}
          sx={{
            textDecoration: 'none',
          }}>
          <Button text='Terms & Conditions' target='_blank' symbol='arrow' />
        </Link>
        <Typography variant='body1' sx={{ mt: '1.6rem', mb: '0.6rem' }}>
          Want to become a partner? Reach out to hello@the100club.io
        </Typography>
      </Grid>
      <ImageGrid gridSize={6} src={heroBannerImage} alt={'Hero Banner'} maxWidth={{ maxWidth: '400px' }} />
    </Grid>
  );
};

export default HeroBanner;
